// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { toDate as fn } from "../toDate.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const toDate = convertToFP(fn, 2);

// Fallback for modularized imports:
export default toDate;
